import { ToastContainer } from 'modules/toast/ToastContainer';
import { FC, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useApplicationCount } from 'shared/hooks/useApplicationCount';
import { Navbar } from './components/Navbar/Navbar';
import { Topbar } from './components/Topbar/Topbar';
import { useApplicationStatusRealtimer } from './hooks/useApplicationStatusRealtimer';
import { useExtractionNotifications } from './hooks/useExtractionNotifications';
import { useNotificationRealtimer } from './hooks/useNotificationRealtimer';

export const LoggedLayout: FC = () => {
  const [navbarOpen, setNavbarOpen] = useState(false);

  useExtractionNotifications();
  useApplicationCount();
  useNotificationRealtimer();
  useApplicationStatusRealtimer();

  return (
    <>
      <ToastContainer />
      <main className="relative grid min-h-full-device w-full gap-4 bg-lightBlue lg:grid-cols-[256px_1fr] lg:bg-white">
        <Navbar open={navbarOpen} onClose={() => setNavbarOpen(false)} />
        <div className="w-full lg:col-start-2">
          <Topbar onHamburgerClick={() => setNavbarOpen(true)} />
          <div className="mt-14 max-w-container px-4 py-8 md:mt-17 md:pl-6 md:pr-10">
            <Outlet />
          </div>
        </div>
      </main>
    </>
  );
};
